import { PropsWithChildren, createContext, useContext, useState } from "react";
import { Media } from "types/qbank/media";

type OpenState = {
  open: true;
  media: Media;
};
type CloseState = {
  open: false;
};

type ModalState = OpenState | CloseState;

type IProps = PropsWithChildren<{ initialState: ModalState }>;

const MediaModalContext = createContext<{
  modal: ModalState;
  setModal: (data: ModalState) => void;
}>(undefined!);

export const MediaModalProvider = ({ initialState, children }: IProps) => {
  const [modal, setModal] = useState<ModalState>(initialState);

  return (
    <MediaModalContext.Provider value={{ modal, setModal }}>
      {children}
    </MediaModalContext.Provider>
  );
};

export const useMediaModal = () => useContext(MediaModalContext);
